import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { AuthService } from '@core/services/auth.service';

@Injectable({ providedIn: 'root' })
export class RoleGuard implements CanActivate {
  private authService = inject(AuthService);
  private router = inject(Router);

  canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean | UrlTree {
    if (!this.authService.isAuthenticated()) {
      return this.router.createUrlTree(['/login']);
    }

    if (!this.authService.hasRole('PROVEEDOR_PRODUCTO')) {
      return true;
    }

    const url = state.url.split('?')[0];
    const allowedPrefixes = [
      '/dashboard',
      '/proveedores/despachos',
      '/proveedores/ordenes-compra',
    ];

    const isAllowed = allowedPrefixes.some((prefix) => {
      // Permitir el prefijo y sus subrutas.
      return url === prefix || url.startsWith(`${prefix}/`);
    });

    if (!isAllowed) {
      return this.router.createUrlTree(['/error']);
    }

    return true;
  }
}
